import { Map } from "../functions/Map"
import { RandomFloat } from "./RandomFloat"

export function RandomInteger(
  n: number,
  min: number,
  max: number,
  seed: number
): Iterable<number> {
  return Map(Math.floor, RandomFloat(n, min, max + 1, seed))
}
